export default function _teamModals () {
  const modalTriggers = document.querySelectorAll('.js-bio-modal-trigger')

  // Open
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', (ev) => {
      ev.preventDefault()
      const modal = document.querySelector('.js-bio-modal[data-profile="' + trigger.dataset.profile + '"]')
      if (!modal) return
      modal.classList.add('active')
    })
  })

  // Close buttons
  const modalCloseTriggers = document.querySelectorAll('.js-bio-modal-close')
  modalCloseTriggers.forEach(trigger => {
    trigger.addEventListener('click', (ev) => {
      ev.preventDefault()
      const modal = trigger.closest('.js-bio-modal')
      if (!modal) return
      modal.classList.remove('active')
    })
  })

  // Close on click of overlay
  const modals = document.querySelectorAll('.js-bio-modal')
  modals.forEach(modal => {
    modal.addEventListener('click', (ev) => {
      if (ev.target === modal) {
        modal.classList.remove('active')
      }
    })
  })
}
